
export const postAssetItem = async (assetItem) => {
  const formData = new FormData()
  formData.append('file', assetItem.files[0], assetItem.files[0].name)
  formData.append('item_id', assetItem.item_id)
  formData.append('item_type', assetItem.item_type)
  const req = await fetch(`${process.env.API_URL}/assign/asset`, {
    method: 'POST',
    body: formData,
    credentials: 'include'
  })
  return await req
}
